import React from 'react';

import { Button, createStyles, Drawer, Stack, Select } from '@mantine/core';
import PackageMultiSelect from 'components/form-fields/auto-complete-fields/PackageMultiSelect';
import AthleteStatusSelect from 'components/form-fields/select-fields/AthleteStatusSelect';

const useStyles = createStyles(theme => ({
  drawer: {
    justifyContent: 'flex-start',
  },
  button: {
    width: 'min-content',
    marginLeft: 'auto',
    marginBottom: theme.spacing.md,
  },
}));

interface FilterTerms {
  searchTerm: string;
  isArrangeByLastName: boolean;
  athleteStatus: string;
  packages: string[];
  loginEnabled: string;
  hasPaymentMethod: string;
  hasSignedWaiver: string;
}

interface ISchedulingPageHeaderProps {
  opened: boolean;
  searchFilters: FilterTerms;
  initialSearchFiltersValue: FilterTerms;
  setSearchFilters: React.Dispatch<React.SetStateAction<FilterTerms>>;
  closeFilters: () => void;
  permission?: boolean;
}

const FiltersDrawer = ({
  opened,
  searchFilters,
  initialSearchFiltersValue,
  setSearchFilters,
  closeFilters,
}: ISchedulingPageHeaderProps): JSX.Element => {
  const { classes } = useStyles();

  const handleAthletePackageChange = (value: string[] | undefined): void => {
    setSearchFilters(prevValue => ({ ...prevValue, packages: value || [] }));
  };
  const handleAthleteStatusChange = (value: string | null): void => {
    setSearchFilters(prevValue => ({ ...prevValue, athleteStatus: value || '' }));
  };

  const handleClearFilters = (): void => {
    setSearchFilters(initialSearchFiltersValue);
  };

  const handleAthleteLoginStatusChange = (value: string | null): void => {
    setSearchFilters(prevValue => ({ ...prevValue, loginEnabled: value || '' }));
  };
  const handleHasPaymentMethodChange = (value: string | null): void => {
    setSearchFilters(prevValue => ({ ...prevValue, hasPaymentMethod: value || '' }));
  };
  const handleHasSignedWaiverChange = (value: string | null): void => {
    setSearchFilters(prevValue => ({ ...prevValue, hasSignedWaiver: value || '' }));
  };

  return (
    <Drawer position='bottom' opened={opened} onClose={closeFilters} className={classes.drawer}>
      <Stack spacing='sm' justify='flex-start'>
        <Button color='red' onClick={handleClearFilters} className={classes.button}>
          Clear Filters
        </Button>

        <PackageMultiSelect
          placeholder='Select packages'
          value={searchFilters?.packages}
          onChange={handleAthletePackageChange}
        />

        <AthleteStatusSelect
          placeholder='Select status'
          value={searchFilters?.athleteStatus}
          onChange={handleAthleteStatusChange}
          clearable
        />

        <Select
          placeholder='Select login status'
          value={searchFilters?.loginEnabled}
          onChange={handleAthleteLoginStatusChange}
          data={[
            { label: 'Enabled', value: 'true' },
            { label: 'Disabled', value: 'false' },
          ]}
          clearable
        />
        <Select
          placeholder='Filter by payment methods'
          value={searchFilters?.hasPaymentMethod}
          onChange={handleHasPaymentMethodChange}
          data={[
            { label: 'Has payment method(s)', value: 'true' },
            { label: 'Has no payment methods', value: 'false' },
          ]}
          clearable
        />
        <Select
          placeholder='Filter by waiver'
          value={searchFilters?.hasSignedWaiver}
          onChange={handleHasSignedWaiverChange}
          data={[
            { label: 'Has waiver', value: 'true' },
            { label: 'Has no waiver', value: 'false' },
          ]}
          clearable
        />
      </Stack>
    </Drawer>
  );
};

export default FiltersDrawer;
